import React, { useState } from "react";

/**
 * RangeBar
 * Vertical range bar representing [min, max] with a median dot.
 * Shows a custom tooltip on hover.
 */
const RangeBar = ({ min, max, media, domainMin, domainMax, color, tooltipText }) => {
  const [isHovered, setIsHovered] = useState(false);
  const range = domainMax - domainMin || 1;

  const bottomPct = Math.max(0, Math.min(100, ((min - domainMin) / range) * 100));
  const heightPct = Math.max(1, Math.min(100 - bottomPct, ((max - min) / range) * 100));
  const mediaPct  = Math.max(0, Math.min(100, ((media - domainMin) / range) * 100));

  const isW1      = color === "#94A3B844";
  const dotColor  = isW1 ? "#64748B" : color;
  const lineColor = isW1 ? "rgba(148, 163, 184, 0.25)" : `${color}40`;

  return (
    <div
      style={{ position: "relative", height: "100%", width: "100%" }}
      title={isHovered ? "" : tooltipText}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Range vertical line */}
      <div
        style={{
          position: "absolute",
          bottom: `${bottomPct}%`,
          height: `${heightPct}%`,
          width: "6px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: lineColor,
          borderRadius: "3px",
          transition: "all 0.3s ease",
        }}
      />

      {/* Median dot */}
      {media !== undefined && media !== null && (
        <div
          style={{
            position: "absolute",
            bottom: `calc(${mediaPct}% - 5px)`,
            left: "50%",
            transform: "translateX(-50%)",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: dotColor,
            boxShadow: "0 1px 2.5px rgba(0, 0, 0, 0.18)",
            zIndex: 10,
            transition: "all 0.3s ease",
          }}
          title={isHovered ? "" : tooltipText}
        />
      )}

      {/* Custom tooltip */}
      {isHovered && tooltipText && (
        <div
          style={{
            position: "absolute",
            bottom: `calc(${mediaPct}% + 10px)`,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(15, 23, 42, 0.95)",
            color: "#ffffff",
            padding: "8px 12px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            lineHeight: "1.4",
            whiteSpace: "pre-line",
            textAlign: "center",
            minWidth: "80px",
            maxWidth: "180px",
            zIndex: 100,
            pointerEvents: "none",
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {tooltipText}
          <div
            style={{
              width: 0,
              height: 0,
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderTop: "5px solid rgba(15, 23, 42, 0.95)",
              position: "absolute",
              bottom: "-4px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default RangeBar;
